export default __webpack_public_path__ + "static/media/lights-and-electronics.108092bb.svg";